module.exports = __webpack_public_path__ + "img/footer-arrow-right.fadffc69.svg";